import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9565f024")

_pushScopeId("data-v-9565f024")
const _hoisted_1 = { class: "mb-32 ml-8 mr-8 text-gray-333" }
const _hoisted_2 = { class: "flex mb-6" }
const _hoisted_3 = { class: "flex items-center mr-5 font-bold font-size-24" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider-gray mb-12" }, null, -1)
const _hoisted_5 = { class: "mb-12 font-size-18" }
const _hoisted_6 = { class: "mb-2 flex" }
const _hoisted_7 = { class: "w-46 text-right mr-10" }
const _hoisted_8 = { class: "mb-2 flex" }
const _hoisted_9 = { class: "w-46 text-right mr-10" }
const _hoisted_10 = { class: "mb-2 flex" }
const _hoisted_11 = { class: "w-46 text-right mr-10" }
const _hoisted_12 = { class: "flex justify-between p-5" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "flex font-bold" }
const _hoisted_15 = { class: "text-light-blue cursor-pointer hover:opacity-75 mr-10 pt-2" }
const _hoisted_16 = {
  key: 1,
  class: "text-light-blue cursor-pointer hover:opacity-75 pt-2"
}
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "text-light-blue underline" }
const _hoisted_19 = { rowspan: "2" }
const _hoisted_20 = { rowspan: "2" }
const _hoisted_21 = { class: "text-left p-3" }
const _hoisted_22 = { class: "flex items-center mb-1" }
const _hoisted_23 = { class: "ml-2" }
const _hoisted_24 = {
  key: 0,
  rowspan: "2"
}
const _hoisted_25 = {
  key: 1,
  rowspan: "2"
}
const _hoisted_26 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_27 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_28 = { class: "pl-3 mt-1 w-full text-center text-white font-size-12" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "flex justify-end cp-icon-chevron-down text-2xl" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "bg-white border rounded-sm absolute top-0 right-0 transition duration-150 ease-in-out origin-top-left min-w-32"
}
const _hoisted_31 = { class: "h-32 overflow-auto scrollbar-hide" }
const _hoisted_32 = { class: "flex justify-center mb-1" }
const _hoisted_33 = { class: "mt-1 mr-1" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "p-1" }, "~", -1)
const _hoisted_35 = { class: "flex justify-center" }
const _hoisted_36 = { class: "mt-1 mr-1" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "p-1" }, "~", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Table = _resolveComponent("Table")
  const _component_ShiftTimeManagerCreatePopup = _resolveComponent("ShiftTimeManagerCreatePopup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('shiftCreation')), 1),
      _createVNode(_component_Input, {
        class: "w-104",
        radius: "59px",
        icon: _ctx.iconSearch,
        placeholder: _ctx.t('searchByName')
      }, null, 8, ["icon", "placeholder"])
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('shiftPlanName')), 1),
        _createVNode("span", null, _toDisplayString(_ctx.requirementPersonnelRegisterShiftDetail.shift_plan_name), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('departmentForShiftCreation')), 1),
        _createVNode("span", null, _toDisplayString(_ctx.displayUnitName()), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('creationTargetPeriod')), 1),
        _createVNode("span", null, _toDisplayString(_ctx.displayRegisterDate(_ctx.requirementPersonnelRegisterShiftDetail)), 1)
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-light-blue-2 mr-6 font-bold",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitShiftHasBeenConfirmed(_ctx.employeeShiftTimeSelectedList)))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('batchConfirmation')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.statusNewShift === _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-light-blue-2 mr-6 font-bold",
              onClick: _ctx.returnShiftCreate
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('returnScreen')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-secondary-c4 text-black mr-6 font-bold",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitAbleToCancelTheShift(_ctx.employeeShiftTimeSelectedList)))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('cancelAllBatchConfirmation')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-green mr-6 font-bold",
              onClick: _ctx.submitAbleToNotifyTheShift
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('bulkNotification')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 4,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-secondary-c4 text-black mr-6 font-bold",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (
            _ctx.submitCancelTheNotificationOfTheShift(_ctx.employeeShiftTimeSelectedList)
          ))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('cancelAllNotifications')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_14, [
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              disabled: _ctx.employeeShiftTimeSelectedList.length === 0,
              class: "btn-gradation-secondary-7d w-28 mr-10",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (
            _ctx.submitPostManagerRegisterShiftForPersonnel(
              _ctx.employeeShiftTimeSelectedList
            )
          ))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('keep')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('excelDownload')), 1),
        (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
          ? (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(_ctx.t('import')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_Table, {
        class: "text-center",
        "fixed-header": "",
        headers: _ctx.membersToSubmittedHeaders,
        data: _ctx.requirementPersonnelRegisterShiftDetail.shift_plan_employees,
        "show-select": ""
      }, {
        "header-checkbox": _withId(() => [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.isAllEmployeeShiftTimeList,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isAllEmployeeShiftTimeList = $event)),
            class: "justify-center",
            disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
            onChange: _ctx.choseAllEmployeeShiftTime
          }, null, 8, ["modelValue", "disabled", "onChange"])
        ]),
        "header-date": _withId(({ item }) => [
          _createVNode("div", _hoisted_18, _toDisplayString(item.text), 1)
        ]),
        body: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formValue.employees, (item, index) => {
            return (_openBlock(), _createBlock(_Fragment, { key: index }, [
              _createVNode("tr", null, [
                _createVNode("td", _hoisted_19, [
                  _createVNode(_component_Checkbox, {
                    key: index,
                    class: "justify-center",
                    value: item.pp_employee_id,
                    modelValue: _ctx.employeeShiftTimeSelectedList,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.employeeShiftTimeSelectedList = $event)),
                    disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS
                  }, null, 8, ["value", "modelValue", "disabled"])
                ]),
                _createVNode("td", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("img", {
                        src: _ctx.AvatarSample,
                        alt: ""
                      }, null, 8, ["src"]),
                      _createVNode("div", _hoisted_23, _toDisplayString(item.full_name), 1)
                    ])
                  ])
                ]),
                (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
                  ? (_openBlock(), _createBlock("td", _hoisted_24, [
                      (
                    _ctx.requirementPersonnelRegisterShiftDetail
                      .shift_plan_employees[index].shift_confirmation_status ===
                    _ctx.SHIFT_CONFIRMATION_STATUS.CANCEL
                  )
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "btn-gradation-light-blue-2 font-bold",
                            onClick: ($event: any) => (
                    _ctx.submitShiftHasBeenConfirmed([
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].pp_employee_id,
                    ])
                  )
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('confirmToRelease')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "btn-gradation-secondary-c4 font-bold text-black",
                            disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
                            onClick: ($event: any) => (
                    _ctx.submitAbleToCancelTheShift([
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].pp_employee_id,
                    ])
                  )
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('confirmToRelease')), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
                  ? (_openBlock(), _createBlock("td", _hoisted_25, [
                      (
                    _ctx.requirementPersonnelRegisterShiftDetail
                      .shift_plan_employees[index].shift_notification_status ===
                    _ctx.SHIFT_NOTIFICATION_STATUS.CANCEL
                  )
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "btn-gradation-green font-bold",
                            onClick: ($event: any) => (
                    _ctx.submitAbleToNotifyTheShift([
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].pp_employee_id,
                    ])
                  )
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('noticeCancellation')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "btn-gradation-secondary-c4 font-bold text-black",
                            onClick: ($event: any) => (
                    _ctx.submitCancelTheNotificationOfTheShift([
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].pp_employee_id,
                    ])
                  )
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('noticeCancellation')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("td", null, _toDisplayString(_ctx.t('hope')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(
                  Array(
                    _ctx.requirementPersonnelRegisterShiftDetail.target_dates.length
                  ).keys()
                ), (item, indexDate) => {
                  return (_openBlock(), _createBlock("td", { key: indexDate }, [
                    (_ctx.isShowExpectWorkInfo(index, indexDate))
                      ? (_openBlock(), _createBlock("div", _hoisted_26, _toDisplayString(_ctx.displayEmployeeExpertType(
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].date_info[indexDate]
                        .shift_plan_employee_day
                    )), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isShowExpectWorkInfo(index, indexDate))
                      ? (_openBlock(), _createBlock("div", _hoisted_27, _toDisplayString(_ctx.displayEmployeeExpertInfo(
                      _ctx.requirementPersonnelRegisterShiftDetail
                        .shift_plan_employees[index].date_info[indexDate]
                        .shift_plan_employee_day
                    )), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createVNode("tr", null, [
                _createVNode("td", null, [
                  _createVNode("div", null, _toDisplayString(_ctx.t('scheduledToWork')), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(
                  Array(
                    _ctx.requirementPersonnelRegisterShiftDetail.target_dates.length
                  ).keys()
                ), (item, indexDate) => {
                  return (_openBlock(), _createBlock("td", { key: indexDate }, [
                    _createVNode("div", null, [
                      _createVNode("div", {
                        class: "form-dropdown cursor-pointer h-6 mb-2 w-56 m-auto",
                        style: {
                      background: _ctx.getBackgroundManagerConfirmType(
                        _ctx.formValue.employees[index].days[indexDate]
                          .manager_confirm_type
                      ),
                    }
                      }, [
                        _createVNode("div", {
                          class: "flex",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowOptionTime = !_ctx.isShowOptionTime))
                        }, [
                          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.getTextManagerConfirmType(
                            _ctx.formValue.employees[index].days[indexDate]
                              .manager_confirm_type
                          )), 1),
                          _hoisted_29
                        ]),
                        (_ctx.isShowOptionTime)
                          ? (_openBlock(), _createBlock("ul", {
                              key: 0,
                              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowOptionTime = false)),
                              class: "bg-white text-gray-333 max-h-62 z-50 border group-hover:scale-100 rounded-sm transform scale-0 absolute transition duration-150 ease-in-out origin-top min-w-32"
                            }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionManagerConfirmTypeList, (item) => {
                                return (_openBlock(), _createBlock("li", {
                                  class: ["rounded-sm px-3 py-1 hover:bg-gray-100 relative", 
                          _ctx.formValue.employees[index].days[indexDate]
                            .manager_confirm_type === item.value
                            ? 'form-dropdown--item-active'
                            : ''
                        ],
                                  key: item.value,
                                  onClick: ($event: any) => (_ctx.toggleSelect(index, indexDate, item))
                                }, [
                                  _createTextVNode(_toDisplayString(item.text) + " ", 1),
                                  (
                            item.value ===
                            _ctx.MANAGER_CONFIRM_TYPE.FROM_WORK_PATTERN
                          )
                                    ? (_openBlock(), _createBlock("ul", _hoisted_30, [
                                        _createVNode("div", _hoisted_31, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shiftPatternData, (item) => {
                                            return (_openBlock(), _createBlock("li", {
                                              class: ["px-3 py-1 hover:bg-gray-100", 
                                _ctx.formValue.employees[index].days[indexDate]
                                  .confirmed_shift_pattern_id ===
                                item.shift_pattern_id
                                  ? 'form-dropdown--item-active'
                                  : ''
                              ],
                                              key: item.shift_pattern_id,
                                              onClick: ($event: any) => (
                                _ctx.toggleSelectShiftPattern(item, index, indexDate)
                              )
                                            }, _toDisplayString(item.shift_pattern_name), 11, ["onClick"]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 10, ["onClick"]))
                              }), 128))
                            ], 32))
                          : _createCommentVNode("", true)
                      ], 4),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('diligent')), 1),
                        _createVNode(_component_InputTime, {
                          modelValue: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .work_start_time
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.formValue.employees[index].days[indexDate]
                          .work_start_time
                       = $event),
                          class: "w-24 h-8",
                          height: "32px",
                          disabled: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .manager_confirm_type !==
                          _ctx.MANAGER_CONFIRM_TYPE.ADD_MANUALLY ||
                        _ctx.statusNewShift === _ctx.ITEM_STATUS
                      
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        _hoisted_34,
                        _createVNode(_component_InputTime, {
                          modelValue: 
                        _ctx.formValue.employees[index].days[indexDate].work_end_time
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.formValue.employees[index].days[indexDate].work_end_time
                       = $event),
                          class: "w-24",
                          height: "32px",
                          disabled: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .manager_confirm_type !==
                          _ctx.MANAGER_CONFIRM_TYPE.ADD_MANUALLY ||
                        _ctx.statusNewShift === _ctx.ITEM_STATUS
                      
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _createVNode("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('stop')), 1),
                        _createVNode(_component_InputTime, {
                          modelValue: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .break_start_time
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.formValue.employees[index].days[indexDate]
                          .break_start_time
                       = $event),
                          class: "w-24",
                          height: "32px",
                          disabled: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .manager_confirm_type !==
                          _ctx.MANAGER_CONFIRM_TYPE.ADD_MANUALLY ||
                        _ctx.statusNewShift === _ctx.ITEM_STATUS
                      
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        _hoisted_37,
                        _createVNode(_component_InputTime, {
                          modelValue: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .break_end_time
                      ,
                          "onUpdate:modelValue": ($event: any) => (
                        _ctx.formValue.employees[index].days[indexDate]
                          .break_end_time
                       = $event),
                          class: "w-24",
                          height: "32px",
                          disabled: 
                        _ctx.formValue.employees[index].days[indexDate]
                          .manager_confirm_type !==
                          _ctx.MANAGER_CONFIRM_TYPE.ADD_MANUALLY ||
                        _ctx.statusNewShift === _ctx.ITEM_STATUS
                      
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", null, [
      _createVNode("span", {
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openShiftTimeCreatePopup && _ctx.openShiftTimeCreatePopup(...args))),
        class: "cp-icon-plus mt-1 text-light-blue cursor-pointer hover:opacity-75"
      }, _toDisplayString(_ctx.t('addTargetPerson')), 1)
    ]),
    _createVNode(_component_ShiftTimeManagerCreatePopup, {
      modelValue: _ctx.isShowShiftTimeCreatePopup,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowShiftTimeCreatePopup = $event)),
      onOnClose: _ctx.closeShiftTimeCreatePopup
    }, null, 8, ["modelValue", "onOnClose"])
  ]))
})